/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tag } from '../../models/tag';

export interface FindTagByIdAdmin$Params {
  id: string;
  children?: boolean;
}

export function findTagByIdAdmin(http: HttpClient, rootUrl: string, params: FindTagByIdAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<Tag>> {
  const rb = new RequestBuilder(rootUrl, findTagByIdAdmin.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('children', params.children, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tag>;
    })
  );
}

findTagByIdAdmin.PATH = '/admin/tags/{id}';
